import { GoogleSpreadsheet as Spreadsheet } from 'google-spreadsheet';

// Preserve the library API and mutable row objects used by save/delete flows.
export class GoogleSpreadsheet extends Spreadsheet {
  constructor(id) {
    if (!id) throw new Error('Please select an organisation before loading its data.');
    super(id);
    this.axios.defaults.timeout = 30000;
  }

  async useServiceAccountAuth(...args) {
    let timer;
    try {
      await Promise.race([
        super.useServiceAccountAuth(...args),
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            const error = new Error('Authentication timed out');
            error.code = 'ECONNABORTED';
            reject(error);
          }, 30000);
        }),
      ]);
    } finally {
      clearTimeout(timer);
    }
  }
}
